import { Chart } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

// Patch for legacy plugins
$.browser = $.browser || {};
$.browser.msie = /MSIE|Trident/.test(window.navigator.userAgent);

Chart.register(annotationPlugin);
